var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "booking-block",
    {
      ref: "bookingblock",
      staticClass: "booking-block--traveler",
      attrs: {
        valid: !_vm.validForm,
        title: _vm.header,
        subTitle: _vm.subTitle,
        trackingTitle: _vm.standardTitle,
        editMode: _vm.editMode
      },
      on: {
        save: _vm.saveAndClose,
        edit: function($event) {
          _vm.$emit("edit")
        }
      }
    },
    [
      _c("template", { slot: "edit" }, [
        _c(
          "div",
          { staticClass: "input-fields" },
          [
            _c(
              "div",
              { staticClass: "input-fields__content" },
              [
                _vm.value.type !== "K"
                  ? _c("selector", {
                      staticClass: "booking-field booking-field--gender",
                      attrs: {
                        value: _vm.value.type,
                        options: _vm.genderOptions,
                        "icon-type": "drop-down"
                      },
                      on: {
                        input: function(type) {
                          return _vm.updateData({ type: type })
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("input-field", {
                  staticClass: "booking-field booking-field--firstname",
                  attrs: {
                    name: _vm.translations.input_firstname,
                    value: _vm.value.firstName,
                    "icon-type":
                      _vm.validForm && _vm.validForm.firstName
                        ? ""
                        : this.checkmarkIcon
                  },
                  on: {
                    input: function(inp) {
                      return _vm.updateData({ firstName: inp })
                    }
                  }
                }),
                _vm._v(" "),
                _c("input-field", {
                  staticClass: "booking-field booking-field--lastname",
                  attrs: {
                    name: _vm.translations.input_lastname,
                    value: _vm.value.lastName,
                    "icon-type":
                      _vm.validForm && _vm.validForm.lastName
                        ? ""
                        : this.checkmarkIcon
                  },
                  on: {
                    input: function(inp) {
                      return _vm.updateData({ lastName: inp })
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.errors.firstName || _vm.errors.lastName
              ? _c("msg-block", { attrs: { type: "error" } }, [
                  _vm.errors.firstName
                    ? _c("p", [
                        _c("b", {
                          domProps: {
                            textContent: _vm._s(_vm.errors.firstName[0])
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.lastName
                    ? _c("p", [
                        _c("b", {
                          domProps: {
                            textContent: _vm._s(_vm.errors.lastName[0])
                          }
                        })
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-fields" },
          [
            _c("div", { staticClass: "input-fields__header" }, [
              _c("h3", {
                domProps: {
                  textContent: _vm._s(_vm.translations.birthday_header)
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-fields__content" },
              [
                _c("selector", {
                  staticClass: "booking-field booking-field--day",
                  attrs: {
                    options: _vm.days,
                    "icon-type":
                      _vm.day == "-1" ? "drop-down" : this.checkmarkIcon
                  },
                  model: {
                    value: _vm.day,
                    callback: function($$v) {
                      _vm.day = $$v
                    },
                    expression: "day"
                  }
                }),
                _vm._v(" "),
                _c("selector", {
                  staticClass: "booking-field booking-field--month",
                  attrs: {
                    options: _vm.months,
                    "icon-type":
                      _vm.month == "-1" ? "drop-down" : this.checkmarkIcon
                  },
                  model: {
                    value: _vm.month,
                    callback: function($$v) {
                      _vm.month = $$v
                    },
                    expression: "month"
                  }
                }),
                _vm._v(" "),
                _c("selector", {
                  staticClass: "booking-field booking-field--year",
                  attrs: {
                    options: _vm.years,
                    "icon-type":
                      _vm.year == "-1" ? "drop-down" : this.checkmarkIcon
                  },
                  model: {
                    value: _vm.year,
                    callback: function($$v) {
                      _vm.year = $$v
                    },
                    expression: "year"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.errors.dateOfBirth
              ? _c("msg-block", { attrs: { type: "error" } }, [
                  _vm.errors.dateOfBirth
                    ? _c("p", [
                        _c("b", {
                          domProps: {
                            textContent: _vm._s(_vm.errors.dateOfBirth[0])
                          }
                        })
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-fields" },
          [
            _c("div", { staticClass: "input-fields__header" }, [
              _c("h3", {
                domProps: {
                  textContent: _vm._s(_vm.translations.nationality_header)
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-fields__content" },
              [
                _c("selector", {
                  staticClass: "booking-field booking-field--country",
                  attrs: {
                    options: _vm.nationality,
                    value: _vm.value.nationality,
                    "icon-type":
                      _vm.validForm && _vm.validForm.nationality
                        ? "drop-down"
                        : this.checkmarkIcon
                  },
                  on: {
                    input: function(val) {
                      return _vm.updateData({ nationality: val })
                    }
                  }
                }),
                _vm._v(" "),
                _c("selector", {
                  staticClass: "booking-field booking-field--citizenship",
                  attrs: {
                    options: _vm.nationalityOrigin,
                    value: _vm.value.residenceCountryCode,
                    "icon-type":
                      _vm.validForm && _vm.validForm.residenceCountryCode
                        ? "drop-down"
                        : this.checkmarkIcon
                  },
                  on: {
                    input: function(val) {
                      return _vm.updateData({ residenceCountryCode: val })
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.errors.nationality || _vm.errors.residenceCountryCode
              ? _c("msg-block", { attrs: { type: "error" } }, [
                  _vm.errors.nationality
                    ? _c("p", [
                        _c("b", {
                          domProps: {
                            textContent: _vm._s(_vm.errors.nationality[0])
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.residenceCountryCode
                    ? _c("p", [
                        _c("b", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.errors.residenceCountryCode[0]
                            )
                          }
                        })
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "view" }, [
        _c("table", { staticClass: "table" }, [
          _c("tbody", [
            _vm.value.type !== "K" && _vm.selectedGender
              ? _c("tr", [
                  _c("td", {
                    domProps: { textContent: _vm._s(_vm.selectedGender) }
                  }),
                  _vm._v(" "),
                  _c("td")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.input_firstname)
                }
              }),
              _vm._v(" "),
              _c("td", {
                domProps: { textContent: _vm._s(_vm.value.firstName) }
              })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.input_lastname)
                }
              }),
              _vm._v(" "),
              _c("td", {
                domProps: { textContent: _vm._s(_vm.value.lastName) }
              })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.birthday_header)
                }
              }),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.birthdayDateMoment
                        ? _vm.birthdayDateMoment.format("LL")
                        : ""
                    ) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(_vm.translations.nationality_ro_field)
                }
              }),
              _vm._v(" "),
              _c("td", {
                domProps: { textContent: _vm._s(_vm.selectedNationality) }
              })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", {
                domProps: {
                  textContent: _vm._s(
                    _vm.translations.nationality_origin_ro_field
                  )
                }
              }),
              _vm._v(" "),
              _c("td", {
                domProps: { textContent: _vm._s(_vm.selectedNationalityOrigin) }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "booking-block__footer" }, [
        _c("div", { staticClass: "booking-block__footer__attention" }, [
          _c("div", { staticClass: "icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 32 32"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M20.57,24.8c0,.19-.15,.34-.34,.34H11.77c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h1.95v-8h-1.95c-.19,0-.34-.15-.34-.34v-1.61c0-.19,.15-.34,.34-.34h6.18c.19,0,.34,.15,.34,.34v9.95h1.95c.19,0,.34,.15,.34,.34v1.61ZM16,5.66c1.29,0,2.34,1.05,2.34,2.34s-1.05,2.34-2.34,2.34-2.34-1.05-2.34-2.34,1.05-2.34,2.34-2.34Zm0-5.66C7.16,0,0,7.17,0,16s7.16,16,16,16,16-7.17,16-16S24.84,0,16,0Z"
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", {
            domProps: { textContent: _vm._s(_vm.translations.notice) }
          })
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-359ccc70", { render: render, staticRenderFns: staticRenderFns })
  }
}